import "core-js/modules/es.object.entries";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      detailsArr: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(diff_details, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var details, _i, _Object$entries, _Object$entries$_i, key, value, transObj, _i2, _Object$entries2, _Object$entries2$_i, _key, _value;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                details = diff_details || {};

                if (type == 'data') {
                  _this.detailsArr = [];

                  for (_i = 0, _Object$entries = Object.entries(details); _i < _Object$entries.length; _i++) {
                    _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                    transObj = {};

                    if ('order_count' in value) {
                      transObj['订单总数'] = value.order_count;
                    }

                    if ('total_amount' in value) {
                      transObj['总金额'] = value.total_amount ? value.total_amount / 100 : 0;
                    }

                    _this.detailsArr.push({
                      label: key,
                      value: JSON.stringify(transObj)
                    });
                  }
                }

                if (type == 'diff') {
                  _this.detailsArr = [];

                  for (_i2 = 0, _Object$entries2 = Object.entries(details); _i2 < _Object$entries2.length; _i2++) {
                    _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), _key = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];

                    _this.detailsArr.push({
                      label: _key,
                      value: _value
                    });
                  }
                }

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};